export default __webpack_public_path__ + "static/media/p7-2.a872bfca.png";